import React from "react";
import Quiz from "../Quiz";

const questions = [
  {
    questionText: "What does the CPU in a computer do?",
    options: [
      "Stores your photos",
      "Connects to the internet",
      "Makes decisions and runs programs",
      "Cools the computer",
    ],
    correct: "Makes decisions and runs programs",
  },
  {
    questionText: "Which part of the computer is known as short-term memory?",
    options: ["Hard drive", "RAM", "CPU", "Graphics card"],
    correct: "RAM",
  },
  {
    questionText: "RAM keeps your files safe even after you shut down the computer.",
    options: ["True", "False"],
    correct: "False",
  },
  {
    questionText: "What is the function of a graphics card?",
    options: [
      "Keeps files organized",
      "Powers the whole computer",
      "Makes visuals appear on the screen",
      "Connects to Wi-Fi",
    ],
    correct: "Makes visuals appear on the screen",
  },
  {
    questionText: "What part connects all the computer’s components?",
    options: ["CPU", "RAM", "Hard Drive", "Motherboard"],
    correct: "Motherboard",
  },
  {
    questionText: "What does ‘Ctrl + Z’ do in MS Word?",
    options: ["Zooms in", "Saves the file", "Undoes the last action", "Closes the program"],
    correct: "Undoes the last action",
  },
  {
    questionText:
      "You should use a red font on a yellow background in documents to make it stand out.",
    options: ["True", "False"],
    correct: "True",
  },
  {
    questionText: "Why is it helpful to use headings in a document?",
    options: [
      "To take up space",
      "To break it into sections and make it easier to read",
      "To change the background color",
      "To confuse your teacher",
    ],
    correct: "To break it into sections and make it easier to read",
  },
  {
    questionText: "What tab do you click to change the font style and size in MS Word?",
    options: ["Insert", "Layout", "View", "Home"],
    correct: "Home",
  },
  {
    questionText: "Which feature automatically checks for spelling mistakes?",
    options: ["Grammar Fixer", "Spell Checker", "Editor", "Proof Reader"],
    correct: "Spell Checker",
  },
  {
    questionText: "You should always post your home address on your social media profile.",
    options: ["True", "False"],
    correct: "False",
  },
  {
    questionText: "What should you do if someone is being mean to you online?",
    options: ["Keep quiet", "Be mean back", "Tell a trusted adult", "Post about it online"],
    correct: "Tell a trusted adult",
  },
  {
    questionText: "The internet never __________ what you post.",
    options: ["saves", "updates", "forgets", "remembers"],
    correct: "forgets",
  },
  {
    questionText: "What is one way to protect yourself from cyberbullying?",
    options: [
      "Keep it to yourself",
      "Block and report the bully",
      "Give them your password",
      "Reply with threats",
    ],
    correct: "Block and report the bully",
  },
  {
    questionText: "Why is it important to sit correctly while using a computer?",
    options: [
      "To fall asleep",
      "To watch movies",
      "To avoid injury and pain",
      "To type slower",
    ],
    correct: "To avoid injury and pain",
  },
  {
    questionText: "What is the correct position for your screen?",
    options: [
      "Far away to make you squint",
      "Right above eye level",
      "Below your knees",
      "At eye level or slightly below",
    ],
    correct: "At eye level or slightly below",
  },
  {
    questionText: "How often should you take breaks from the computer?",
    options: [
      "Every 5 hours",
      "Only on weekends",
      "Every 20–30 minutes",
      "When your teacher says so",
    ],
    correct: "Every 20–30 minutes",
  },
  {
    questionText: "What should your feet be doing while you sit at a computer?",
    options: [
      "Dangling in the air",
      "Crossed and elevated",
      "Flat on the floor",
      "Resting on your chair",
    ],
    correct: "Flat on the floor",
  },
  {
    questionText: "Which part of your hand should be supported while typing?",
    options: ["Elbow", "Wrist", "Fingers", "Thumb"],
    correct: "Wrist",
  },
  {
    questionText: "Why is posture important when using a computer?",
    options: [
      "To impress others",
      "To prevent strain and stay healthy",
      "To stretch your spine",
      "To balance your chair",
    ],
    correct: "To prevent strain and stay healthy",
  },
];

export default function ComputerSkillsQuiz8({ studentInfo, onComplete }) {
  return <Quiz studentInfo={studentInfo} questions={questions} onComplete={onComplete} />;
}
